<script>

import Dialog from 'primevue/dialog';
import TreeTable from 'primevue/treetable';
import Column from 'primevue/column';
 
export default {
    components: {Dialog, TreeTable, Column},
    props: ['item', 'caller'],
    data(){
        return{
            visible: false,
            itemValues: [],
            itemLabel: {
                keys: "logs.key",
                value:"logs.value"
            }
        }
    },
    mounted(){
    },
    methods: {
        show(){
            this.visible = true;
        },
        closeModal(){
            this.visible=false;
        },
        generateElement(){         
            this.itemValues = [];
            for(var key in this.item.value){

                if(Array.isArray(this.item.value[key])){
                    
                    let children = [];

                    for(let i=0; i<this.item.value[key].length; i++){

                        let subChildren = []

                        for(var subKey in this.item.value[key][i]){
                            subChildren.push({
                                key: subKey + '-' + i,
                                data: {
                                    key: subKey,
                                    val: this.item.value[key][i][subKey]
                                }
                            })
                        }

                        children.push({
                            key: key + '-' + i,
                            data: {
                                key: i
                            },
                            children: subChildren
                        })
                        
                    }
                    this.itemValues.push({
                        key: key,
                        data: {
                            key: key
                        },
                        children: children
                    })
                }else{
                    this.itemValues.push({
                        key: key,
                        data: {
                            key: key,
                            val: this.item.value[key]
                        }
                    })
                }
            }
        }
    }
}

</script>



<template>
    <Dialog :header="item.title ? $t(item.title): ''" v-model:visible="visible" :modal="true"  style="width:50%;">                
      
        <TreeTable :value="itemValues"> 
            <Column field="key" :header="$t('logs.key')" :expander="true"></Column>
            <Column field="val" :header="$t('logs.value')" :expander="true"></Column>
        </TreeTable>           
    </Dialog>
</template> 